import type { Action } from '../types';

interface UsersState {
  config: Record<string, any>;
  helpPage: string;
  alerts: any[];
}

const initialState = { config: {}, helpPage: '', alerts: [] };

export default function reducer(
  state: UsersState = initialState,
  action: Action<any>,
): UsersState {
  switch (action.type) {
    case 'setConfig':
      return {...state, config: action.response};
    case 'setHelpPage':
      return {...state, helpPage: action.response};
    case 'alert':
      return {...state, alerts: action.response};
    case 'closeAlert':
      return {
        ...state,
        alerts: state.alerts.filter((_, i) => i !== action.response),
      };
    default:
      return state;
  }
}